import React from "react";
//#region types
import { WintSuperkollAPIModelSurveys } from "wint-api-client/dist/types";
import { FormHandles } from "models/propTypes/genericFormProps";
import { SurveyFormContainerProps } from "models/propTypes/surveyPropsTypes";
//#endregion
//#region components
import SurveyForm from "./surveyForm";
import { useDynamicFormInitialValues, useDynamicFormSubmit, useDynamicFormValidationSchema } from "components/common";
//#endregion
import * as Yup from "yup";
import { useSurveyService } from "serviceHooks";

const SurveyFormContainer: React.ForwardRefRenderFunction<FormHandles, SurveyFormContainerProps> = (props, ref) => {
  const surveyService = useSurveyService();
  const { questionGroups, answers, groupAnswers, isFinal } = props;

  const { getInitialValues } = useDynamicFormInitialValues(questionGroups, answers, groupAnswers);
  const { getValidationSchemaObj } = useDynamicFormValidationSchema(questionGroups);
  const { getFieldValue, getAnswer } = useDynamicFormSubmit();

  const initialValues = React.useMemo(() => {
    return getInitialValues();
  }, [questionGroups]);

  const validationSchema = React.useMemo(() => {
    const fields = getValidationSchemaObj();
    return Yup.object<any>(fields);
  }, [props.id]);

  const getAnswers = (values: any): WintSuperkollAPIModelSurveys.AnswerModel[] => {
    const questions = questionGroups.flatMap((qg) => qg.questions);

    return questions.map((question) => {
      const value = getFieldValue(values, question?.id);
      return question ? getAnswer(question, value) : ({} as WintSuperkollAPIModelSurveys.AnswerModel);
    });
  };

  const getGroupAnswers = (values: any): WintSuperkollAPIModelSurveys.GroupAnswerModel[] => {
    const optionalGroups = questionGroups.filter((qg) => qg.isOptional);
    return optionalGroups.flatMap((questionGroup) => {
      const isGroupEnabled = getFieldValue(values, questionGroup.id);
      return isGroupEnabled !== undefined
        ? {
            questionGroupId: questionGroup.id,
            isEnabled: !!isGroupEnabled,
          }
        : [];
    });
  };

  const handleSubmit = (values: any, isFinal: boolean) => {
    return surveyService.saveSurvey({
      surveyId: props.id,
      answers: getAnswers(values),
      groupAnswers: getGroupAnswers(values),
      isFinal: isFinal,
    });
  };

  return (
    <SurveyForm
      ref={ref}
      {...props}
      questionGroups={questionGroups}
      defaultValues={initialValues}
      validationSchema={validationSchema}
      handleSubmit={handleSubmit}
      isFinal={isFinal}
    />
  );
};

export default React.forwardRef(SurveyFormContainer);
